import NextLink, { LinkProps as NextLinkProps } from "next/link";

const Link: React.FC<NextLinkProps & { className?: string; title?: string, target?: string }> =
  ({ href, children, target = "_self", ...props }) => {
    return (
      <NextLink href={href}>
        <a {...props} target={target}>{children}</a>
      </NextLink>
    );
  };

export default Link;
